import React, {useState} from "react";
import TransactionQueryForm from "./TransactionQueryForm";
import TransactionQueryTable from "./TransactionQueryTable";
import {FormHeader, H1} from "../../styles/globalStyles";
import {QueryTransactionPage} from "./TransactionQueryStyles";

export default () => {

    const [transactions, setTransactions] = useState(null);

    return (
      <QueryTransactionPage>

          <FormHeader>
            <H1>Member Transaction History</H1>
          </FormHeader>

          <TransactionQueryForm
            setTransactions={setTransactions}
          />

          <TransactionQueryTable
              transactions={transactions}
          />

      </QueryTransactionPage>
    );
}